<template>
  <div class="page">
    <div class="centered-box locations-white locations-generic events-panel">
      <div class="row">
        <div class="col">
          <div class="events-title">Events</div>
          <div class="event-copy">
            <section class="event-section">
              <h2 class="event-name">
                <a href="#/Twilight">Twilight Nature Paddle</a>
              </h2>
              <p>
                Whether you’re an experienced paddler or complete beginner, join us and we’ll show you why these guided trips have become a customer favorite. Children welcome (minimum age 8 years; must be accompanied by an adult).
              </p>
              <p>
                <strong>
                  From our Clark Park Boathouse. Seats limited. Contact us to reserve your single kayak, tandem kayak, or canoe. Let us know your preferred date and the number and type of boats required.
                </strong>
              </p>
              <div class="event-price">
                Price: Single kayak—$35*; Tandem kayak or canoe—$50*<br>
                <i class="small-note">*Plus 15% Chicago Entertainment Tax</i>
              </div>
            </section>
            <section class="event-section dates-section">
              <strong>Upcoming dates:</strong>
            <table class="upcoming-dates-table">
              <tbody>
                <tr>
                  <td>Saturday, <strong>June 13</strong> 5:30 p.m.</td>
                  <td>Saturday, <strong>June 27</strong> 6:00 p.m.</td>
                </tr>
                <tr>
                  <td>Saturday, <strong>July 11</strong> 6:00 p.m.</td>
                  <td>Saturday, <strong>July 25</strong> 6:00 p.m.</td>
                </tr>
                <tr>
                  <td>Saturday, <strong>August 8</strong> 6:00 p.m.</td>
                  <td>Saturday, <strong>August 22</strong> 6:00 p.m.</td>
                </tr>
                <tr>
                  <td>Saturday, <strong>September 5</strong> 5:30 p.m.</td>
                  <td>Saturday, <strong>September 12</strong> 5:30 p.m.</td>
                </tr>
              </tbody>
            </table>
            </section>
            <div class="text-center event-contact">
              <a class="btn-primary btn" href="#/GroupContact">
                <strong>Contact</strong>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Events",
  props: {
    msg: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.space {
  display: flex;
  justify-content: space-between;
  width: 300px;
}
.cell-bg-red {
  background-color: #f4cccc;
}

.cell-bg-green {
  background-color: #b6d7a8;
}

.cell-bg-blue {
  background-color: #cfe2f3;
}

.table-bordered th,
.table-bordered td {
  border-color: black;
  text-align: center;
}
.upcoming-dates-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 0.5rem;
}
.upcoming-dates-table td {
  color: black;
  padding: 0.4rem 0.8rem;
  text-align: left;
  vertical-align: top;
}
.upcoming-dates-table tr {
  border-bottom: 1px solid #999;
}
.left {
  text-align: left;
  /* font-weight: bolder; */
}
.blue {
  color: #007bff;
  font-weight: bolder;
}
.page {
  background-image: url("../../assets/Clouds.jpg");
  flex-direction: column;
}
.page .events-panel {
  box-sizing: border-box;
  width: min(820px, calc(100vw - 20px));
  max-width: none;
  font-weight: normal;
}
.events-title {
  margin-bottom: 18px;
  font-family: Georgia, "Times New Roman", serif;
  font-size: 28px;
  font-weight: 700;
  text-align: center;
}
.event-section {
  padding: 12px 0;
  border-bottom: 1px solid #999;
}
.event-section p {
  margin-bottom: 12px;
}
.event-name {
  margin: 0 0 12px;
  font-size: 20px;
  font-weight: 700;
}
.event-name a {
  color: inherit;
}
.event-price {
  line-height: 1.5;
}
.dates-section {
  padding-bottom: 8px;
}
.event-contact {
  display: flex;
  justify-content: center;
  padding-top: 18px;
}
.responsiveCal {
  position: relative;
  padding-bottom: 75%;
  height: 0;
  overflow: hidden;
}
.responsiveCal iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.small-note {
  font-size: 0.85rem;
  font-style: italic;
}

.btn-primary {
  margin: 0;
  text-align: center;
  display: inline-block;
}
</style>
